import Api from "../Api";

const basePath = '/dealer';

export default {
  getDealerPlanningConfiguration: () => Api.get(`${basePath}/planning-configuration`),
  saveDealerPlanningConfiguration: (body) => Api.post(`${basePath}/planning-configuration`, body)
}
